import { PlusCircle, Settings, Users, CreditCard } from "lucide-react";
import { useNavigate } from "react-router-dom";

const quickActions = [
  { 
    icon: PlusCircle, 
    bg: "from-indigo-500 to-purple-600", 
    label: "Start New Prototype",
    path: "/app/new-prototype"
  },
  { 
    icon: Settings, 
    bg: "from-sky-400 to-blue-500", 
    label: "Book a Machine",
    path: "/app/machines"
  },
  { 
    icon: Users, 
    bg: "from-fuchsia-500 to-pink-600", 
    label: "Consult an Expert",
    path: "/app/experts"
  },
  { 
    icon: CreditCard, 
    bg: "from-orange-400 to-rose-500", 
    label: "Pay Pending Invoice",
    path: "/app/payments"
  },
];

export default function QuickActions() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-6 h-full">
      <h2 className="font-bold text-gray-900 mb-4">Quick Actions</h2>
      <div className="flex flex-col gap-2">
        {quickActions.map(({ icon: Icon, bg, label, path }) => (
          <button
            key={label}
            onClick={() => handleNavigation(path)}
            className="flex items-center justify-between px-3 py-3 rounded-xl hover:bg-gray-50 transition text-left w-full"
          >
            <span className="flex items-center gap-3">
              <span className={`w-9 h-9 rounded-lg bg-gradient-to-br ${bg} flex items-center justify-center shrink-0`}>
                <Icon className="w-4 h-4 text-white" />
              </span>
              <span className="text-sm font-medium text-gray-900">{label}</span>
            </span>
            <span className="text-gray-400">↗</span>
          </button>
        ))}
      </div>
    </div>
  );
}